<template>
    <v-container fluid class="page-container">
        <page-header title="Articles" :subtitle="totalLabel">
            <v-btn color="primary" depressed @click="createItem">
                <v-icon left>mdi-plus</v-icon>New article
            </v-btn>
        </page-header>

        <filter-panel :fields="filterFields" :value="listState" :loading="loading" @apply="applyFilters" />

        <v-card outlined>
            <v-data-table
                :headers="visibleHeaders"
                v-bind="tableBindings"
                class="list-table clickable-rows"
                no-data-text="No articles match this search"
                @update:options="onTableOptions"
                @click:row="openItem($event)"
            >
                <template v-slot:[`item.title`]="{ item }">
                    <span class="font-weight-medium">{{ item.title }}</span>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">{{ formatDate(item.createdAt) }}</template>
                <template v-slot:[`item.isAnouncement`]="{ item }">
                    <v-chip v-if="item.isAnouncement" x-small color="info" outlined>Announcement</v-chip>
                    <v-chip v-if="item.isPromo" x-small color="secondary" outlined class="ml-1">Promo</v-chip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-end">
                        <v-btn icon small color="primary" title="Edit" @click.stop="openItem(item, 'edit')">
                            <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <delete-button title="Delete this article?" @delete-entry="deleteItem(item, deleteArticle, 'Article')" />
                    </div>
                </template>
            </v-data-table>
            <table-footer v-model="page" :page-count="pageCount" :total="total" :items-per-page="itemsPerPage" />
        </v-card>
    </v-container>
</template>

<script>
    import articleService from '@/services/article-service'
    import paginatedList from '@/mixins/paginated-list'
    import PageHeader from '@/components/PageHeader'
    import FilterPanel from '@/components/FilterPanel'
    import TableFooter from '@/components/TableFooter'
    import DeleteButton from '@/components/DeleteButton'
    import { formatDate } from '@/utils/format'

    export default {
        name: 'ArticleRoute',
        components: { PageHeader, FilterPanel, TableFooter, DeleteButton },
        mixins: [paginatedList],
        data() {
            return {
                filterFields: [
                    { key: 'search', label: 'Search', placeholder: 'Title or announcement title' }
                ],
                headers: [
                    { text: 'Title', value: 'title' },
                    { text: 'Announcement title', value: 'announcementTitle' },
                    { text: 'Type', value: 'isAnouncement' },
                    { text: 'Created', value: 'createdAt' },
                    { text: '', value: 'actions', align: 'end', sortable: false, width: 96 }
                ]
            }
        },
        methods: {
            formatDate,
            fetchPage: options => articleService.getArticlesPage(options),
            deleteArticle: id => articleService.deleteArticleById(id)
        }
    }
</script>
